import { render, staticRenderFns } from "./DispatchLocations.vue?vue&type=template&id=194719ae&"
import script from "./DispatchLocations.vue?vue&type=script&lang=ts&"
export * from "./DispatchLocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports